<template>
  <DanhSachApp />
</template>

<script>
import DanhSachApp from "@/components/pages/quan-tri-he-thong/app/DanhSachApp.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

export default {
  name: "TrangDanhSachApp",
  components: {
    DanhSachApp
  },
  created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.APP.NAME
      }`
    );
  }
};
</script>


